<template>
  <div>
    <div v-if="$store.state.users.userid === -1">
      <div>
        <van-loading class="user-loading" size="40px" vertical
          >加载中...</van-loading
        >
      </div>
    </div>
    <div v-if="$store.state.users.userid !== -1">
      <!--    顶部图片和头像区域 -->
      <div class="user-profile">
        <van-image
          round
          width="5rem"
          height="5rem"
          v-bind:src="$store.state.users.headimgurl"
        >
          <template v-slot:loading>
            <van-loading type="spinner" size="20" />
          </template>
        </van-image>
        <div>{{ $store.state.users.nickname }}</div>
      </div>

      <van-cell-group class="user-group">
        <van-cell
          icon="records"
          title="我的面授课程"
          is-link
          @click="toMyCourse"
        />
        <!--        <van-cell-->
        <!--          icon="balance-list-o"-->
        <!--          title="我的订单"-->
        <!--          is-link-->
        <!--          @click="disabled"-->
        <!--        />-->
      </van-cell-group>

      <van-cell-group class="user-group">
        <!--        <van-cell icon="contact" title="个人信息" is-link @click="disabled" />-->
        <van-cell
          icon="orders-o"
          title="我的开票信息"
          is-link
          @click="toInvoice"
        />
      </van-cell-group>
      <div v-if="$store.state.users.is_staff">
        <van-divider />
        <h4 style="margin-left: 10px">管理功能</h4>
        <van-cell-group>
          <van-cell
            icon="contact"
            title="报名统计"
            is-link
            @click="toAdminSummary"
          />
          <van-cell icon="bill-o" is-link @click="toAdminVerifySubList">
            <!-- 使用 title 插槽来自定义标题 -->
            <template #title>
              <span class="custom-title">优惠审核</span>
              <van-tag
                type="danger"
                v-if="
                  $store.state.admin.verify_sub.submissions !== null &&
                    $store.state.admin.verify_sub.submissions.length > 0
                "
                >{{ $store.state.admin.verify_sub.submissions.length }}</van-tag
              >
            </template>
          </van-cell>
          <van-cell icon="bill-o" is-link @click="toAdminVerifySubList">
            <!-- 使用 title 插槽来自定义标题 -->
            <template #title>
              <span class="custom-title">其他方式支付审核</span>
              <van-tag
                type="danger"
                v-if="
                  $store.state.admin.verify_pay.verifications !== null &&
                    $store.state.admin.verify_pay.verifications.length > 0
                "
                >{{
                  $store.state.admin.verify_pay.verifications.length
                }}</van-tag
              >
            </template>
          </van-cell>
          <van-cell
            icon="description"
            is-link
            @click="toDeleteAdminCourseInfos"
          >
            <!-- 使用 title 插槽来自定义标题 -->
            <template #title>
              <span class="custom-title" style="color: red"
                >删除我报名的课程</span
              >
            </template>
          </van-cell>
          <van-cell icon="user-o" is-link @click="toDeleteAdminStudent">
            <!-- 使用 title 插槽来自定义标题 -->
            <template #title>
              <span class="custom-title" style="color: red"
                >删除我的报名信息及课程</span
              >
            </template>
          </van-cell>
        </van-cell-group>
      </div>

      <MainTabBar></MainTabBar>
    </div>
  </div>
</template>

<script>
import {
  Icon,
  Cell,
  CellGroup,
  Image as VanImage,
  Loading,
  Tag,
  Divider,
  Dialog
} from "vant";
import { warningNotify } from "@/utils/notify";
import {
  delete_admin_course_infos,
  delete_admin_student
} from "@/services/admin";

import MainTabBar from "@/components/MainTabBar";

export default {
  data() {
    return {};
  },
  methods: {
    toInvoice() {
      this.$router.push({ name: "invoice" });
    },
    toMyCourse() {
      this.$router.push({ path: "/myCourse" });
    },
    toAdminSummary() {
      this.$router.push({ name: "admin_summary" });
    },
    toAdminVerifySubList() {
      this.$router.push({ name: "admin_verify_sub_list" });
    },
    disabled() {
      warningNotify("暂未开放访问！");
    },
    toDeleteAdminCourseInfos() {
      Dialog.confirm({
        message: "将删除您填写的所有报名的课程，确定要删除吗？"
      })
        .then(() => {
          delete_admin_course_infos(this.$store.state.users.token).then(
            result => {
              if (!result.status) {
                warningNotify("删除失败！");
                return false;
              }
              if (!result.data.status) {
                warningNotify(result.data.message);
                return false;
              }
              Dialog.alert({
                message: "已删除！"
              });
            }
          );
        })
        .catch(() => {});
    },
    toDeleteAdminStudent() {
      Dialog.confirm({
        message: "将删除您填写的所有报名信息以及报名的课程，确定要删除吗？"
      })
        .then(() => {
          delete_admin_student(this.$store.state.users.token).then(result => {
            if (!result.status) {
              warningNotify("删除失败！");
              return false;
            }
            if (!result.data.status) {
              warningNotify(result.data.message);
              return false;
            }
            this.$store.commit("student_init_student");
            Dialog.alert({
              message: "已删除！"
            });
          });
        })
        .catch(() => {});
    }
  },
  components: {
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    "van-divider": Divider,
    "van-cell-group": CellGroup,
    [VanImage.name]: VanImage,
    [Loading.name]: Loading,
    "van-tag": Tag,
    MainTabBar
  },
  beforeMount() {
    // 应该在每个登录才能操作的视图加上下面这句
    this.$store.dispatch("users_tokenChecker");
    this.$store.state.system.tabBarActive = "user";
    if (this.$store.state.users.is_staff) {
      this.$store.commit("admin/verify_sub/initSubmissions");
      this.$store.dispatch("admin/verify_sub/toGetSubmissions");
    }
  },
  updated() {
    if (
      this.$store.state.users.is_staff &&
      this.$store.state.admin.verify_sub.submissions === null
    ) {
      this.$store.dispatch("admin/verify_sub/toGetSubmissions");
    }
  }
};
</script>

<style lang="less">
.user {
  &-poster {
    width: 100%;
    height: 53vw;
    display: block;
  }

  &-group {
    margin-bottom: 15px;
  }

  &-links {
    padding: 15px 0;
    font-size: 12px;
    text-align: center;
    background-color: #fff;

    .van-icon {
      display: block;
      font-size: 24px;
    }
  }
  &-profile {
    text-align: center;
    margin: 10px auto;
  }
  &-loading {
    width: 80px;
    height: 50px;
    position: fixed;
    top: 20%;
    left: 0;
    right: 0;
    margin: 0 auto;
    color: #1989fa;
  }
}
</style>
